<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="login()">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" v-model="username" :class="{'is-invalid': error}"  @keypress.native="error = false" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password" :class="{'is-invalid': error}" @keypress.native="error = false"/>
                  </b-input-group>
                  <transition name="fade">
                    <b-alert show variant="danger" style="width: 100%;" v-if="error">Wrong credentials!</b-alert>
                  </transition>
                  <b-row>
                    <!-- <div class="col-md-3 py-4">
                      <h6>expand-left</h6>
                      <button class="btn btn-primary ladda-button" id="login-button" data-style="expand-right" type="submit">Login</button>
                    </div> -->
                    <b-col cols="6">
                      <b-button variant="primary" class="btn btn-primary ladda-button" id="login-button" data-style="expand-right" type="submit">Login</b-button>
                      <!-- <button class="btn btn-primary ladda-button" id="login-button" data-style="expand-right" type="submit">Login</button> -->
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"><a href="mailto:wexcedo@wexcedo.com">Forgot password?</a></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import api from '../api'
import config from '../config'
import store from '../store'
import router from '../router'
import * as Ladda from 'ladda'

export default {
  name: 'Login',
  data: function () {
    return {
      token: null,
      username: null,
      password: null,
      error: false,
      loginButton: null
    }
  },
  mounted: function() {
    this.loginButton = Ladda.create(document.querySelector( '#login-button' ))
  },
  methods: {
    login: function () {
      this.loginButton.start()
      api.request('get', config.serverURI + 'tokens', null, {
          uname: this.username,
          upass: this.password,
          token: btoa(Math.floor(new Date() / 1000))
        })
        .then(response => {
          // store.commit('SET_TOKEN', response.data)
          window.localStorage.setItem('token', response.data)
          router.push('/')
        })
        .catch(error => {
          this.error = true
          console.log(this.loginButton)
          this.loginButton.stop()
        })
    }
  }
}
</script>
<style>
  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px); */
    opacity: 0;
  }
</style>
